import {
  computeIndividualPrime,
  computeAge,
  affiliationTypeLabel,
} from "@/constants/sante-config";

export default {
  santeStep: (s) => s.currentStep,
  santePhase: (s) => s.appPhase,
  santeSubmissionRef: (s) => s.submissionRef,

  santeForm: (s) => s.form,
  santeAdherent: (s) => s.form.adherent,
  santeAffiliations: (s) => s.form.affiliations,
  santeActiveAffiliationIndex: (s) => s.activeAffiliationIndex,
  santeActiveAffiliation: (s) =>
    s.form.affiliations[s.activeAffiliationIndex] || null,

  santeFiles: (s) => s.files,
  santeFilesFor: (s) => (personId) =>
    s.files[personId] || { photo: null, acte: null },

  santeErrors: (s) => s.errors,
  santeAdherentErrors: (s) => s.errors.adherent,
  santeAffiliationErrors: (s) => (idx) => s.errors.affiliations[idx] || {},
  santeDeclarationError: (s) => s.errors.declaration,
  santeSubmitError: (s) => s.errors.submit,
  isSanteSubmitting: (s) => s.loading.submit,

  // ── Toutes les personnes assurées (adhérent + affiliés) ──
  santeAllInsured: (s) => [s.form.adherent, ...s.form.affiliations],

  // ── Prime par personne (calcul arrière-plan, taux masqués) ──
  // Renvoie une Map indexée par id → { prime, base, age, rate, eligible }
  santePrimeByPerson: (s) => {
    const out = {};
    [s.form.adherent, ...s.form.affiliations].forEach((p) => {
      out[p.id] = computeIndividualPrime(p);
    });
    return out;
  },

  // ── Prime individuelle d'une personne donnée ──
  santePrimeFor: (s, g) => (personId) =>
    g.santePrimeByPerson[personId] || {
      prime: null,
      eligible: false,
      age: null,
    },

  // ── Prime totale (somme des primes éligibles) ──
  santeTotalPrime: (s, g) => {
    return Object.values(g.santePrimeByPerson).reduce(
      (sum, r) => sum + (r.eligible && r.prime ? r.prime : 0),
      0
    );
  },

  // ── Au moins une personne non éligible (âge > 70 ou date manquante) ? ──
  santeHasIneligible: (s, g) =>
    Object.values(g.santePrimeByPerson).some((r) => !r.eligible),

  // ── Récap enrichi pour l'étape finale ──
  santeRecap: (s, g) =>
    [s.form.adherent, ...s.form.affiliations].map((p) => {
      const pr = g.santePrimeByPerson[p.id] || {};
      return {
        id: p.id,
        type: p.type,
        typeLabel:
          p.type === "adherent"
            ? "Adhérent principal"
            : affiliationTypeLabel(p.type),
        fullName: `${p.firstName} ${p.lastName}`.trim() || "—",
        age: computeAge(p.birthDate),
        prime: pr.prime,
        eligible: pr.eligible,
        afflictionCount: (p.afflictionCodes || []).length,
        medicationCount: (p.medications || []).length,
      };
    }),

  // ── Conditions pour pouvoir soumettre ──
  santeCanSubmit: (s, g) =>
    s.form.declarationAccepted &&
    s.form.consentData &&
    !!(s.form.declarationName || "").trim() &&
    !g.santeHasIneligible,
};
